import { render, staticRenderFns } from "./SubmitFormItem.vue?vue&type=template&id=43d69f94&scoped=true"
import script from "./SubmitFormItem.vue?vue&type=script&lang=js"
export * from "./SubmitFormItem.vue?vue&type=script&lang=js"
import style0 from "./SubmitFormItem.vue?vue&type=style&index=0&id=43d69f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d69f94",
  null
  
)

export default component.exports